import ExplainLink from "../../ExplainLink";
import type { AccountRecord } from "../../lib/explainTypes";
import { useAccountResolver } from "../../hooks/useAccountResolver";

interface Props {
  accounts: AccountRecord[];
}

// Strategy === "fallback". Per architecture spec §8 + APP-1238: no
// completion view mounts here. Each account inherits the household
// model.
export default function FallbackAssignmentView({ accounts }: Props) {
  const resolve = useAccountResolver();
  return (
    <div>
      <p className="text-muted">
        Each account inherits the household model directly (no per-account
        preference, no completion strategy).
      </p>
      <ul>
        {accounts.map((a) => {
          const r = resolve(a);
          return (
            <li key={a.account_id}>
              {r.name}
              {r.number && <span className="text-muted"> ({r.number})</span>} (
              {a.account_type}) ←{" "}
              {r.modelName && r.modelId != null ? (
                <ExplainLink to={`/models/models/${r.modelId}`}>
                  {r.modelName}
                </ExplainLink>
              ) : (
                "household model"
              )}
            </li>
          );
        })}
      </ul>
    </div>
  );
}
